import styled from 'styled-components';
import { FilterChipWithMenuMixin } from '../../mixins/components/FilterChipWithMenuMixin';
export var StyledFilterChipWithMenu = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledFilterChipWithMenu",
  componentId: "c11n-8-111-1__sc-ve3d1m-0"
})(["", ""], FilterChipWithMenuMixin);